<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card:hover {
  background: #f1f2f6;
  cursor: pointer;
}

.ActionRow {
    position: absolute;
    bottom: 0;
    right: 0;
}

.link-text-white >>> a,
.link-text-white >>> a span
{
  color: #fff !important
}



</style>

<style>
.navbar-dark .navbar-nav .nav-link {
  color: #fff !important
}

.link-text-white .dropdown-item:hover{
  color: #000 !important
}


.nav-fix{
  z-index: 9999;
}

</style>

<template>
    <b-navbar toggleable="md" type="dark" variant="info" class="nav-fix">

    <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>

    <!-- <b-navbar-brand to="/" :title="CompanyName">{{CompanyNameShort}}</b-navbar-brand> -->
    <b-navbar-brand to="/" :title="CompanyName">
      <!-- <img src="./static/Choice-Paper-Logo-Website.webp" alt="Kitten"> -->
      <b-img src="./static/Choice-Paper-Logo-Website.webp"  width="200" />
    </b-navbar-brand>

    <b-nav-form class="m-1 d-md-none d-lg-none d-xl-none">
          <b-button size="sm" class="my-2 my-sm-0 " variant="primary" v-on:click="openCart">Cart <b-badge variant="light">{{cartCount}}</b-badge></b-button>
    </b-nav-form>

    <b-collapse is-nav id="nav_collapse">

      <b-navbar-nav type="dark" variant="info">
        <b-nav-item-dropdown text="Products" extra-menu-classes="bg-info text-white border-0 link-text-white">
          <b-dropdown-item v-for="(item, index) in visibleCatalog" :key="index" class="bg-info text-white link-text-white" v-on:click="ShowCategory(item)">{{item.Name}}</b-dropdown-item>
        </b-nav-item-dropdown>
        <!-- <b-nav-item class="bg-info text-white link-text-white" :to="{ name: 'Quick' }">Quick Order</b-nav-item> -->
        <b-nav-item class="bg-info text-white link-text-white" :to="{ name: 'OrderHistory' }">Order History</b-nav-item>
        <!-- <b-nav-item class="bg-info text-white link-text-white"  :to="{ name: 'FileManager' }">Files</b-nav-item> -->
      </b-navbar-nav>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">

        <b-nav-item-dropdown right v-if="userInfo" extra-menu-classes="bg-info text-white border-0">
          <!-- Using button-content slot -->
          <template slot="button-content">
            <em v-if="company">Company: {{company.Name}}</em>
            <em v-else>Select a Company</em>
          </template>
          
          <b-dropdown-item class="bg-info text-white link-text-white" 
            v-for="item in userInfo.Companies" 
            :key="item.Oid"
            v-on:click="setCompany(item)"
          >
            {{item.Name}}
          </b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-form v-on:submit.prevent="searchProducts">
          <b-input-group size="sm">
            <b-form-input type="text" placeholder="Search" v-model="search" @keyup.enter="searchProducts"></b-form-input>
            <b-input-group-append>
              <b-btn v-on:click="searchProducts">Search</b-btn>
            </b-input-group-append>
          </b-input-group>
        </b-nav-form>

        <b-nav-form class="m-1 d-none d-sm-block">
          <b-button size="sm" class="my-2 my-sm-0" variant="primary" v-on:click="openCart">Cart <b-badge variant="light">{{cartCount}}</b-badge></b-button>
        </b-nav-form>
        
        <b-nav-item-dropdown right v-if="userInfo" extra-menu-classes="bg-info text-white border-0">
          <!-- Using button-content slot -->
          <template slot="button-content">
            <em>{{userInfo.FirstName}} {{userInfo.LastName}}</em>
          </template>
          <b-dropdown-item class="bg-info text-white link-text-white" :to="{ name: 'Profile'}">Profile</b-dropdown-item>
          <b-dropdown-item class="bg-info text-white link-text-white" :to="{ name: 'OrderHistory' }">Order History</b-dropdown-item>
          <b-dropdown-item class="bg-info text-white link-text-white" v-on:click="Signout">Signout</b-dropdown-item>
        </b-nav-item-dropdown>

        <b-nav-item v-else to="/login">Login</b-nav-item>
        <!-- <b-nav-item v-if="!userInfo" to="/signup">Register</b-nav-item> -->

      </b-navbar-nav>

      </b-collapse>
    </b-navbar>
</template>

<script>

import ConfigService from "@/services/ConfigService";
import Swal from 'sweetalert2';

export default {
  name: "AdvancedNav",
  data() {
    return {
      search: "",
      progressValue: 100,
      catalog: []
    };
  },
  created() {
    ConfigService.GetCatalog().then(c => this.catalog = c);
    //this.catalog = ConfigService.GetCatalog(); //Will need to change later as this will be a promise
  },
  computed: {
    userInfo() {
      return this.$store.state.auth.userInfo;
    },
    company() {
      return this.$store.state.auth.company;
    },
    cartCount() {
      return this.$store.state.cart.length;
    },
    CompanyName() {
      return process.env.COMPANY_NAME;
    },
    CompanyNameShort() {
      return process.env.COMPANY_NAME_SHORT;
    },
    visibleCatalog() {
      return this.catalog && this.catalog.filter(c => c.Visible);
    }
  },
  methods: {
    setCompany(comp){
      if(this.$store.state.cart.length > 0){
        Swal.fire({
          title: 'Your Cart is not empty!',
          icon: 'warning',
          text: 'Please finalise this order before changing companies.',
          // showDenyButton: true,
          showCancelButton: true,
          confirmButtonText: 'Open Cart',
          // confirmButtonColor: '#02AC1E',
          // denyButtonText: `Quick Order`,
          // denyButtonColor: '#663399',
          cancelButtonText: `Close`,
        }).then((result) => {
          /* Read more about isConfirmed, isDenied below */
          if (result.isConfirmed) {
              this.$router.push({ path: "/cart" });
          } 
          // else if (result.isDenied) {
          //     this.$router.push({ name: 'Quick' });
          // }
        });
      }
      else {
        this.$store.commit("SetCompany", comp);
      }
      
    },
    ShowCategory(item) {
      this.$router.push({ name: "Category", params: { category: item.Name } });
    },
    Signout() {
      this.$store.commit("ClearCredentials");
      this.$router.push({ path: "/login" });
    },
    searchProducts() {
      var query = "";
      if (this.search) {
        if (this.userInfo) {
          query = `Contains(ProductService.Name, '${this.search}') OR Contains(ProductService.Description, '${this.search}')`;
        } else {
          query = `Contains(Name, '${this.search}') OR Contains(Description, '${this.search}')`;
        }
      }
      this.$router.push({ path: "/Products", query: { q: this.search } });
    },
    openCart() {
      this.$router.push({ path: "/cart" });
    },
    // SearchProductByTag(tag) {
    //   var query = "";
    //   if (this.userInfo) {
    //     query = "[ProductService.Tags][Name = '" + tag + "']";
    //   } else {
    //     query = "[Tags][Name = '" + tag + "']";
    //   }
    //   this.$router.push({ path: "/Products", query: { q: query } });
    // }
  },
  components: {
  }
};
</script>





// WEBPACK FOOTER //
// src/components/Nav/AdvancedNav.vue